module.exports = __webpack_public_path__ + "static/media/b2.ee6379ba.jpg";